// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__5RSZQ","error":"Button_error__2fHch","success":"Button_success__2Tkc_","primary":"Button_primary__1WNAB","SignIn":"Button_SignIn__kQy_V"};